module.exports = __webpack_public_path__ + "img/ug332.4d0be3cf.png";